import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-bool-answer',
  templateUrl: './bool-answer.component.html',
  styleUrls: ['./bool-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BoolAnswerComponent {}
